import { NavLink, Outlet } from 'react-router';
import { IconGrid, IconSettings, IconUser, IconUsers } from '../components/icons.js';
import { LegalLinks } from '../pages/SignInPage.js';
import { PilotBanner } from '../components/PilotBanner.js';
import { useApp, useMe } from './context.js';

/** Grundlayout wie im Fahrtenbuch: mobil Kopfzeile + Tab-Leiste, Desktop dunkle Seitenleiste. */
export function Shell() {
  const { session } = useApp();
  const me = useMe();

  if (me.isLoading) return <div className="spinner">Lädt …</div>;
  if (me.error || !me.data) {
    return (
      <div className="boot-message">
        <h1>Fehler</h1>
        <p>{(me.error as Error)?.message ?? 'Unbekannter Fehler'}</p>
        <button className="btn btn--ghost" onClick={session.logout}>Abmelden</button>
      </div>
    );
  }

  const m = me.data;
  const nav = [
    { to: '/', label: 'Start', icon: <IconGrid size={22} />, end: true },
    ...(m.tenantAdmin ? [{ to: '/team', label: 'Team', icon: <IconUsers size={22} />, end: false }] : []),
    ...(m.platformAdmin ? [{ to: '/admin', label: 'Administration', icon: <IconSettings size={22} />, end: false }] : []),
    { to: '/profil', label: 'Profil', icon: <IconUser size={22} />, end: false },
  ];

  return (
    <div className="app">
      {session.pilot && <PilotBanner />}
      <aside className="sidebar">
        <NavLink to="/" className="wordmark" aria-label="Betriebsam – Start">Betriebsam</NavLink>
        {m.tenant && (
          <div className="sidebar__tenant">
            <strong>{m.tenant.name}</strong>
            <span>{m.tenant.status === 'active' ? 'Betrieb' : 'Betrieb gesperrt'}</span>
          </div>
        )}
        <nav aria-label="Hauptnavigation">
          {nav.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end}>
              {n.icon}
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="sidebar__user">
          <strong>{m.name}</strong>
          <span>{m.email}</span>
          <button onClick={session.logout}>{session.mock ? 'Rolle wechseln (Mock)' : 'Abmelden'}</button>
          <LegalLinks />
        </div>
      </aside>

      <div className="app__main">
        <header className="topbar">
          <NavLink to="/" className="wordmark" aria-label="Betriebsam – Start">Betriebsam</NavLink>
          {m.tenant && <span className="eyebrow">{m.tenant.name}</span>}
        </header>
        <Outlet />
        <nav className="bottom-nav" aria-label="Hauptnavigation">
          {nav.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end}>
              {n.icon}
              {n.label === 'Administration' ? 'Admin' : n.label}
            </NavLink>
          ))}
        </nav>
      </div>
    </div>
  );
}
